const ArrowLeft = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      fill="none"
    >
      <path fillRule="evenodd" clipRule="evenodd" d="M8.23657 12.5534C7.92114 12.2478 7.92114 11.7522 8.23657 11.4466L13.6212 6.22922C13.9366 5.92359 14.448 5.92359 14.7634 6.22922C15.0789 6.53485 15.0789 7.03037 14.7634 7.336L9.94994 12L14.7634 16.664C15.0789 16.9696 15.0789 17.4652 14.7634 17.7708C14.448 18.0764 13.9366 18.0764 13.6212 17.7708L8.23657 12.5534Z" fill="currentColor"/>
    </svg>
  )
}

export default ArrowLeft;
